import React from 'react';
import { createNativeStackNavigator } from '@react-navigation/native-stack';
import { AppRoutes } from "navigations/app-routes";
import _ from "lodash";
import { stackProps } from "utils/helper-navigation";
import HelperString from "utils/helper-string";
import { createPageTitle } from 'utils/helper-page-title'
import { useSelector } from 'react-redux'
import { dataConstants } from 'services/redux/data/constants'
import HelperTimeslotKinds from 'utils/helper-timeslot-kinds'
import { useRoute } from '@react-navigation/native'
import ManagementBookingsIndexScene from 'scenes/management/bookings'
import ManagementBookingsViewScene from 'scenes/management/bookings/view'
import ManagementEmployeesEmployeeScene from 'scenes/management/employees/employee'

const Stack = createNativeStackNavigator();

const ManagementBookingsNavigator = ( props ) => {
	
	const route = useRoute();
	const _timeslotKinds = useSelector( state => {
		return state.data[dataConstants.TIMESLOT_KINDS];
	} );
	
	let screens = {}
	
	_.forEach( _timeslotKinds, ( timeslotKind ) => {
		const routeName = HelperTimeslotKinds.managementRouteName( timeslotKind );
		
		// Only get the route with the same route name
		if( route.name === routeName ) {
			screens[ HelperTimeslotKinds.managementRouteName( timeslotKind ) ] = {
				component: ManagementBookingsIndexScene,
				params: {
					kind: timeslotKind.kind,
					subKind: timeslotKind.sub_kind
				}
			}
		}
	});
	
	screens = {
		...screens,
		[AppRoutes.MANAGEMENT_BOOKINGS_ERO]:{
			component: ManagementBookingsIndexScene,
			params: {
				eroOnly: 'yes'
			}
		},
		[AppRoutes.MANAGEMENT_BOOKINGS_VIEW]:{
			component: ManagementBookingsViewScene,
		},
		[AppRoutes.MANAGEMENT_EMPLOYEES_EMPLOYEE_VIEW]: {
			component: ManagementEmployeesEmployeeScene,
		},
	}
	
	return (
		<Stack.Navigator
			{ ...stackProps }>
			
			{ _.map( screens, ( screen, name ) => {
				return (
					<Stack.Screen
						key={ HelperString.hash( `ManagementStatisticsNavigator`, name ) }
						name={ name }
						options={{
							title: createPageTitle( _.get( screen, 'title', null ) )
						}}
						component={ screen.component }
						initialParams={ screen.params }
					/>
				);
			})}
		</Stack.Navigator>
	);
}

export default ManagementBookingsNavigator
